import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import projectData from "../../Data/projectData";

const ProjectSection = () => {
  const sliderRef = useRef(null); // Create a reference for the slider

  const [projects, setProjects] = useState([]);

  useEffect(() => {
    setProjects(projectData);
  }, []);

  // Slider settings
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    ref: sliderRef, // Attach the reference to the slider
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Handle previous and next buttons
  const handlePrev = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const handleNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  return (
    <section
      className="project-sec"
      data-pos-space=".process-sec"
      data-sec-space="margin-top"
      data-margin-top="220px"
    >
      <div
        className="container th-container4 bg-smoke space"
        data-bg-src="/assets/img/update1/bg/bg_pattern_6.png"
      >
        <div className="container">
          <div className="project-card2-wrap">
            <div className="row justify-content-lg-between align-items-end">
              <div className="col-lg-7 mb-n2 mb-lg-0">
                <div className="title-area">
                  <span className="sub-title6">
                    Our PROJECTS
                    <span className="shape right">
                      <span className="dots"></span>
                    </span>
                  </span>
                  <h2 className="sec-title">View Our Client's Projects</h2>
                </div>
              </div>
              <div className="col-auto">
                <div className="sec-btn">
                  <Link to="/project" className="th-btn">
                    VIEW ALL PROJECT
                    <i className="fas fa-arrow-right ms-2"></i>
                  </Link>
                </div>
              </div>
            </div>

            <Slider
              {...settings}
              className="slider-shadow th-carousel"
              id="projectSlide1"
            >
              {projects.map((project) => (
                <div key={project.id} className="col-md-6 col-lg-4 hh">
                  <div className="project-card2">
                    <div className="project-img">
                      <img
                        src={project.imgSrc}
                        alt="project"
                        style={{ height: "320px" }}
                      />
                    </div>
                    <div className="project-content">
                      {/* <p className="project-subtitle">{project.subtitle}</p> */}
                      <h3
                        className="project-title"
                        style={{ minHeight: "70px" }}
                      >
                        <Link to="">{project.title}</Link>
                      </h3>
                      <Link to="" className="project-icon">
                        <i className="far fa-plus"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>

            <div className="icon-box">
              <button onClick={handlePrev} className="slick-arrow default">
                <i className="far fa-arrow-left"></i>
              </button>
              <button onClick={handleNext} className="slick-arrow default">
                <i className="far fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectSection;
